export default "__VITE_ASSET__q1g8sGy8__"